module.exports = __webpack_public_path__ + "img/download-arrow.463e289d.svg";